import { PolicyLayout } from '../components/PolicyLayout';
import { siteDetails } from '../lib/site';

export const Refunds = () => (
  <PolicyLayout eyebrow="Buyer protection" title="Refund Policy" updated="2 August 2026">
    <p>
      We want buyers to understand exactly what they are purchasing and to have a fair opportunity to
      evaluate ADarveo. This policy applies to the ADarveo Pro subscription and one-time scan packs.
    </p>

    <h2>30-day refund window</h2>
    <p>
      You may request a refund within 30 days of a completed purchase. An unused scan pack is eligible
      for a full refund. If some pack scans have already been consumed, we may issue a proportional
      refund for the unused balance. Refunds are returned to the original payment method.
    </p>

    <h2>Subscription renewals</h2>
    <p>
      ADarveo Pro renews automatically every month until cancelled. You can cancel at any time before
      the next billing date to prevent the next charge. Cancellation does not automatically refund a
      completed payment, but payments made within the preceding 30 days may be submitted for review
      under this policy.
    </p>

    <h2>How to request a refund</h2>
    <p>
      Email <a href={`mailto:${siteDetails.supportEmail}`}>{siteDetails.supportEmail}</a> with the buyer
      email address, transaction number, purchase date, and reason for the request. You can also use{' '}
      <a href="https://paddle.net" rel="noreferrer">Paddle buyer support</a> for payment, cancellation,
      receipt, or refund assistance.
    </p>

    <h2>Processing time</h2>
    <p>
      We aim to acknowledge refund requests within two business days. After approval, Paddle processes
      the refund. The time required for funds to appear depends on the buyer’s payment provider.
    </p>

    <h2>Exceptions</h2>
    <p>
      We may decline or reduce a refund where there is evidence of fraud, abuse, repeated refund claims,
      a chargeback already in progress, or substantial consumption of the purchased service. Nothing in
      this policy limits rights that cannot lawfully be excluded in the buyer’s jurisdiction.
    </p>
  </PolicyLayout>
);

